import yup from "src/utils/yup/extensionMethods";

export const schemaUserChangePassword = (translate: Function, isResetPassword: boolean) => yup.object().shape({
	efa005Senha_previous: isResetPassword ? yup.mixed().nullable() : yup.string(),
	efa005Senha: yup.string().min(8, translate("Senha deve ter no mínimo 8 dígitos")).matches(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/, translate("Deve conter 8 caracteres, um maiúsculo, um minúsculo, um número e um caractere especial")),
	efa005Senha_confirmation: yup.string().oneOf([yup.ref("efa005Senha")], translate("As senhas não conferem"))
});

export const schemaUserProfile = (translate: Function) => yup.object().shape({
	efa005Nome: yup.string().required(translate("Nome é obrigatório"))
});

export const schemaTFA = (translate: Function) => yup.object().shape({
	code: yup.string().min(6, translate("Código de verificação é obrigatório")).max(6, translate("Código de verificação é obrigatório"))
});
